import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=34bbeb72&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yoreirei/Documents/project/other/market-ui/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34bbeb72')) {
      api.createRecord('34bbeb72', component.options)
    } else {
      api.reload('34bbeb72', component.options)
    }
    module.hot.accept("./slider.vue?vue&type=template&id=34bbeb72&", function () {
      api.rerender('34bbeb72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lib/slider/src/slider.vue"
export default component.exports